import StatisticProductList from './StatisticProductList'

export default StatisticProductList
